module.exports = __webpack_public_path__ + "314425d865d51fe7ab865e8f3144f821.svg";